import type { AgoraParticipantLike } from '../../types';
import useVideoContext from '../useVideoContext/useVideoContext';
import { sameAgoraParticipant } from '../../utils/sameAgoraParticipant';

/**
 * Agora exposes reconnection state primarily at the client level.
 * We show "Reconnecting..." overlay for the local participant when the client is reconnecting.
 */
export default function useParticipantIsReconnecting(participant: AgoraParticipantLike): boolean {
  const { room } = useVideoContext();
  if (!room) return false;
  const isLocal = sameAgoraParticipant(participant, room.localParticipant);
  if (!isLocal) return false;
  return String(room.connectionState).toLowerCase().includes('reconnecting');
}
